import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ac7e5798"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"color":"#c75450"}
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("只读")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("可编辑")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("隐藏")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_table, {
      "header-cell-style": { background: '#f5f6f6' },
      data: _ctx.formPerms,
      border: "",
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "title",
          "show-overflow-tooltip": "",
          label: "表单字段"
        }, {
          default: _withCtx((scope) => [
            (scope.row.required)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, " * "))
              : _createCommentVNode("", true),
            _createElementVNode("span", null, _toDisplayString(scope.row.title), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "readOnly",
          label: "只读",
          width: "80"
        }, {
          header: _withCtx((scope) => [
            _createVNode(_component_el_radio, {
              label: "R",
              modelValue: _ctx.permSelect,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.permSelect) = $event)),
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.allSelect('R')))
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          default: _withCtx((scope) => [
            _createVNode(_component_el_radio, {
              modelValue: scope.row.perm,
              "onUpdate:modelValue": ($event: any) => ((scope.row.perm) = $event),
              label: "R",
              name: scope.row.id
            }, null, 8, ["modelValue", "onUpdate:modelValue", "name"])
          ]),
          _: 1
        }),
        (_ctx.selectedNode.type !== 'CC')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              prop: "editable",
              label: "可编辑",
              width: "90"
            }, {
              header: _withCtx((scope) => [
                _createVNode(_component_el_radio, {
                  label: "E",
                  modelValue: _ctx.permSelect,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.permSelect) = $event)),
                  onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.allSelect('E')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              default: _withCtx((scope) => [
                _createVNode(_component_el_radio, {
                  modelValue: scope.row.perm,
                  "onUpdate:modelValue": ($event: any) => ((scope.row.perm) = $event),
                  label: "E",
                  name: scope.row.id
                }, null, 8, ["modelValue", "onUpdate:modelValue", "name"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          prop: "hide",
          label: "隐藏",
          width: "80"
        }, {
          header: _withCtx((scope) => [
            _createVNode(_component_el_radio, {
              label: "H",
              modelValue: _ctx.permSelect,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.permSelect) = $event)),
              onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.allSelect('H')))
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          default: _withCtx((scope) => [
            _createVNode(_component_el_radio, {
              modelValue: scope.row.perm,
              "onUpdate:modelValue": ($event: any) => ((scope.row.perm) = $event),
              label: "H",
              name: scope.row.id
            }, null, 8, ["modelValue", "onUpdate:modelValue", "name"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])
  ]))
}